import './main.scss';

import { loadPolyfillv2 } from '@opten/script/load-polyfill';
import factory from '@opten/compiler/factory';

import { CookieBanner } from './components/cookie-banner';
import { Anchor } from './components/anchor';
import { Filter } from './components/filter';
import { IconSlider } from './components/icon-slider';
import { ScrollNextModule } from './components/scroll';
import { ClickableComponent } from './components/clickable';
import { Isotope } from './components/isotope';
import {
	CollapseDefault,
	CollapseMobile,
	CollapseNavigation,
} from './components/collapse';

const cookie = new CookieBanner();

loadPolyfillv2(() => {
	factory([
		Anchor,
		Filter,
		CollapseDefault,
		CollapseMobile,
		CollapseNavigation,
		IconSlider,
		ScrollNextModule,
		ClickableComponent,
		Isotope,
	])(document.body);
});
